import React from 'react';

import { SettingsSaveBarProps } from './SettingsSaveBar';

type SetSaveBar = React.Dispatch<
  React.SetStateAction<SettingsSaveBarProps | null>
>;

/** The current page's save bar, or null when the page has nothing to save. */
export const SettingsSaveBarContext =
  React.createContext<SettingsSaveBarProps | null>(null);

/**
 * The setter on its own, so pages that set the save bar don't re-render when it
 * changes. Setting it from an effect would otherwise loop.
 */
export const SettingsSaveBarSetterContext = React.createContext<SetSaveBar>(
  () => null,
);

/** Provided by the `new-settings` layout only, so the save bar does nothing elsewhere. */
export const SettingsSaveBarProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [saveBar, setSaveBar] = React.useState<SettingsSaveBarProps | null>(
    null,
  );

  return (
    <SettingsSaveBarSetterContext.Provider value={setSaveBar}>
      <SettingsSaveBarContext.Provider value={saveBar}>
        {children}
      </SettingsSaveBarContext.Provider>
    </SettingsSaveBarSetterContext.Provider>
  );
};
